// src/utils/toWords/index.ts

import { enUS } from './en-US';
import { ptBR } from './pt-BR';
import { esES } from './es-ES';
/**
 * import { bnBD } from './bn-BD';
import { deDE } from './de-DE';
import { enUS } from './en-US';
import { enGB } from './en-GB';
import { esES } from './es-ES';
import { faIR } from './fa-IR';
import { frFR } from './fr-FR';
import { guIN } from './gu-IN';
import { haNG } from './ha-NG';
import { hiIN } from './hi-IN';
import { idID } from './id-ID';
import { itIT } from './it-IT';
import { jaJP } from './ja-JP';
import { jvID } from './jv-ID';
import { koKR } from './ko-KR';
import { mrIN } from './mr-IN';
import { paIN } from './pa-IN';
import { ptBR } from './pt-BR';
 */
export const dictionaries = {
    'en-us': enUS,
    'pt-br': ptBR,
    'es-es': esES,
    /**
     *     'bn-bd': bnBD,
    'de-de': deDE,
    'en-us': enUS,
    'en-gb': enGB,
    'es-es': esES,
    'fa-ir': faIR,
    'fr-fr': frFR,
    'gu-in': guIN,
    'ha-ng': haNG,
    'hi-in': hiIN,
    'id-id': idID,
    'it-it': itIT,
    'ja-jp': jaJP,
    'jv-id': jvID,
    'ko-kr': koKR,
    'mr-in': mrIN,
    'pa-in': paIN,
    'pt-br': ptBR,
     */

};
